import InstallButton from "./installButton";

const Footer = () => {
    const user = "baptistchurchalkapur";
    const domain = "gmail.com";
    const email = `${user}@${domain}`;
    return (
        <>
            <footer className="footer-area section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6 col-sm-6">
                            <div className="single-footer-widget">
                                <h6>Baptist Church Alkapoor</h6>
                                <div>
                                    <p className="contact-bold">
                                        Church Timings:
                                    </p>
                                    Every Sunday
                                    ENGLISH SERVICE
                                    <br />
                                    11 AM - 12:30 PM
                                    <br />
                                    <br />
                                    <p className="contact-bold">
                                        Address:
                                    </p>
                                    1st Floor,
                                    Star Celestia Banquet Hall,
                                    <br/>
                                    Ideal Park,
                                    Opp. Netaji Park,
                                    <br />
                                    Road no 16,
                                    Alkapoor Township,
                                    <br />
                                    Hyderabad
                                    <br />
                                    <br />
                                    <p className="contact-bold">
                                        Phone:
                                    </p>
                                    <a href='tel:+919949694869'>
                                        +91 9949694-869
                                    </a>
                                    <br />
                                    <a href={'tel:+918074617330'}>
                                        +91 8074617-330
                                    </a>
                                    <br />
                                    <br />
                                    <p className="contact-bold">
                                        Email:
                                    </p>
                                    <a href={`mailto: ${email}`}>
                                        baptistchurchalkapur@gmail.com
                                    </a>
                                    <br/>
                                    <br/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5  col-md-6 col-sm-6">
                            <div className="single-footer-widget">
                                <h6>Follow Us</h6>
                                <div className="footer-social d-flex align-items-center">
                                    <a href="http://instagram.com/baptistchurchalkapoor" title="Instagram"><i className="fa-brands fa-instagram"></i></a>
                                    <a href="https://www.youtube.com/@AlkapoorBaptistChurch" title="YouTube"><i className="fa-brands fa-youtube"></i></a>
                                </div>
                            </div>
                            <InstallButton />
                            <br/>
                            <div className="single-footer-widget">
                                <h6>Subscribe</h6>
                                <p>Subscribe to push notifications to get updates!</p>
                                <div className="footer-social d-flex align-items-center">
                                    <div className='onesignal-customlink-container'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="single-footer-widget above-arrow" title="Scroll up">
                        <div className="footer-social d-flex align-items-center">
                            <i className="fa fa-arrow-up"
                                onClick={() => {
                                    window.scrollTo({ top: 0 });
                                }}></i>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;